import { render, staticRenderFns } from "./quickNav.vue?vue&type=template&id=37770d09&scoped=true&"
import script from "./quickNav.vue?vue&type=script&lang=js&"
export * from "./quickNav.vue?vue&type=script&lang=js&"
import style0 from "./quickNav.vue?vue&type=style&index=0&id=37770d09&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-co_kc4kqcj5wnuaaoi4dyztoye7yy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37770d09",
  null
  
)

export default component.exports